import {
    ChangeDetectionStrategy,
    Component,
    input,
    computed,
    output,
    ViewEncapsulation,
    inject,
    model,
} from '@angular/core';
import { Animations } from '@fi-shared/utils/animations';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { IOnboardingCompletionData } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion';
import { FiOnboardingCompletionActionsBuilderService } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion-actions-builder.service';
import { IOnboardingActive } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';

@Component({
    selector: 'fi-single-onboarding-card',
    templateUrl: './fi-single-onboarding-card.component.html',
    styleUrl: './fi-single-onboarding-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-single-onboarding-card' },
    standalone: false,
    animations: [Animations.fadeHeight()],
})
export class FiSingleOnboardingCardComponent {
    public isExpanded = model<boolean>(false);
    public currentDisplayedOnboardingCompletion = input.required<IOnboardingCompletionData>();
    public visibleOnboarding = input.required<IOnboardingActive>();
    public isLoading = input<boolean>();

    public displayOnboardingCompletion = output<number>();

    private fiOnboardingCompletionActionsBuilderService = inject(FiOnboardingCompletionActionsBuilderService);

    protected actions = computed<IItemsListAction2<IOnboardingActive>[]>(() => {
        return this.fiOnboardingCompletionActionsBuilderService.getHomeOnboardingSingleActiveOnboardingActions(
            this.visibleOnboarding(),
        );
    });

    protected expandCard(): void {
        if (this.isExpanded()) {
            return;
        }

        this.isExpanded.set(true);
        this.displayOnboardingCompletion.emit(this.visibleOnboarding().Id);
    }

    protected toggleExpansionState($event: MouseEvent): void {
        $event.stopPropagation();
        this.isExpanded.set(!this.isExpanded());
        if (this.isExpanded()) {
            this.displayOnboardingCompletion.emit(this.visibleOnboarding().Id);
        }
    }
}
